import { SpinnerSizes, CustomFlowbiteTheme } from 'flowbite-react';

export interface SpinnerThemeProps {
    base: string;
    color: string; // could be a union type
    size: SpinnerSizes;
}

// you need a text class on the wrapper for some reason for the circle main color. why? ask flowbite
export const SpinnerTheme: CustomFlowbiteTheme['spinner'] = {
    base: 'inline animate-spin',
    color: {
        default: 'fill-primary-600',
        gray: 'fill-gray-600',
        info: 'fill-cyan-600',
        // our variants below
        primary: 'fill-system-primary',
        secondary: 'fill-system-secondary',
        error: 'fill-system-error',
        success: 'fill-system-success',
        warning: 'fill-system-warning',
    },
    light: {
        off: {
            base: 'dark:text-gray-600',
            color: {
                default: '',
                gray: 'dark:fill-gray-300',
                info: '',
                // our variants below
                primary: 'dark:fill-system-primary',
                secondary: 'dark:fill-system-secondary',
                error: 'dark:fill-system-error',
                success: 'dark:fill-system-success',
                warning: 'dark:fill-system-warning',
            },
        },
        on: {
            base: '',
            color: {
                default: '',
                gray: '',
                info: '',
                // our variants below
                primary: '',
                secondary: '',
                error: '',
                success: '',
                warning: '',
            },
        },
    },
    size: {
        xs: 'h-3 w-3',
        sm: 'h-4 w-4',
        md: 'h-6 w-6',
        lg: 'h-8 w-8',
        xl: 'h-10 w-10',
    },
};
